import React, { useState } from "react";
import LeftNotificationPopup from "../../core/NotificationPopup/LeftNotificationPopup";
import ProcessSuccessful from "../../../assets/icons/ProcessSuccessful";
import { cancelSubscription } from "../../../backend-services/subscription";
import { SidebarDrawer } from "../../common";
import { CloseIcon } from "../../../assets/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { showToast } from "../../../utils/toastUtils";

interface cancelSubscriptionPromptProps {
  id: string;
  setShowPrompt: (showPromt: boolean) => void;
  onClose?: () => void;
  onDeleteSuccess?: () => void;
  handleGetActiveSubscription: () => void;
}

const CancelSubscriptionPrompt = ({
  id,
  setShowPrompt,
  onClose,
  onDeleteSuccess,
  handleGetActiveSubscription,
}: cancelSubscriptionPromptProps) => {
  const { t } = useTranslation("subscription");
  const [isCanceling, setIsCanceling] = useState(false);
  const [showSuccessSidebar, setShowSuccessSidebar] = React.useState(false);
  const navigate = useNavigate();

  const closeSuccessSidebar = () => {
    setShowSuccessSidebar(false);
  };

  const handleCancelSubscription = async () => {
    setIsCanceling(true);
    try {
      const res = await cancelSubscription(id);
      setShowSuccessSidebar(true);
      showToast(
        res.message || "Subscription auto renewal has been cancelled",
        "success",
      );
      onDeleteSuccess && onDeleteSuccess();
      handleGetActiveSubscription();
      navigate(`/settings?tab=subscription`);
      setIsCanceling(false);
    } catch (error: any) {
      showToast(error.response?.data || error.message, "error");
      setIsCanceling(false);
      throw new Error(error.message);
    }
  };

  return (
    <>
       <div className="fixed inset-0 bg-black bg-opacity-50 z-50"></div>

{/* Centered Modal */}
<div className="fixed inset-0 flex items-center justify-center z-50">
  <div className="bg-white w-[474px] mx-5 p-6 rounded-lg shadow-lg">
          <div className="">
            <div className="flex items-center justify-between ">
            <div className="text-[20px] font-semibold leading-[28.8px]">
              {" "}
              {t("subscription.cancelPrompt")}
            </div>
              <div onClick={() => setShowPrompt(false)}>
                <CloseIcon color="#000000" />
              </div>
            </div>
          
            <div className="mt-[16px] ">
              <h1>{t("subscription.cancelWarning")}</h1>
              <span>
                {/* You will not be charged on the next subscription <br /> date. */}
                {t("subscription.cancelWarning1")}
              </span>
            </div>
            <div role="form" onSubmit={(e) => e.preventDefault()}>
              <div className="flex gap-[24px] justify-end items-end mt-[25px]">
                {/* <button
                  onClick={onClose}
                  className="border border-[#044E97] rounded-[4px] w-full h-[48px] flex items-center justify-center text-[#044E97] text-[16px] whitespace-nowrap"
                  style={{ fontWeight: 600 }}
                >
                  {t("subscription.continue")}
                </button> */}
                <button
                  className="px-6 h-[48px] flex items-center justify-center rounded-[4px] bg-[#FB0303] text-white font-semibold"
                  onClick={handleCancelSubscription}
                  disabled={isCanceling}
                >
                  {isCanceling ? "Canceling..." : "Yes, Cancel"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showSuccessSidebar && (
        <SidebarDrawer
          title=""
          show={true}
          position="left"
          onClose={closeSuccessSidebar}
        >
          <LeftNotificationPopup
            title="Subscription Canceled"
            icon={<ProcessSuccessful />}
            position="left"
            showSuccessModal={true}
          />
        </SidebarDrawer>
      )}
    </>
  );
};

export default CancelSubscriptionPrompt;
